import React, { useRef, useEffect } from 'react';
import { Card } from 'antd';
import type { SupportMessage } from '../../../services/supportTicketsService';
import { AttachmentViewer } from './AttachmentViewer';
import { formatVnDateTime } from '../../../utils/vnDateTime';

interface TicketThreadProps {
  messages: SupportMessage[];
  loading?: boolean;
}

function formatTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '–';
  const formatted = formatVnDateTime(dateStr, 'HH:mm DD/MM');
  return formatted === '—' ? '–' : formatted;
}

export const TicketThread: React.FC<TicketThreadProps> = ({
  messages,
  loading,
}) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (loading) {
    return (
      <Card loading style={{ minHeight: 200 }}>
        <div ref={bottomRef} />
      </Card>
    );
  }

  if (!messages?.length) {
    return (
      <Card>
        <div style={{ textAlign: 'center', color: '#888', padding: 24 }}>
          Chưa có tin nhắn.
        </div>
        <div ref={bottomRef} />
      </Card>
    );
  }

  return (
    <Card bodyStyle={{ padding: 16 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {messages.map(m => {
          const isAdmin = m.senderType === 'ADMIN';
          return (
            <div
              key={m.id}
              style={{
                display: 'flex',
                justifyContent: isAdmin ? 'flex-start' : 'flex-end',
              }}
            >
              <div
                style={{
                  maxWidth: '75%',
                  padding: '10px 14px',
                  borderRadius: 12,
                  background: isAdmin ? '#f0f0f0' : '#1890ff',
                  color: isAdmin ? '#000' : '#fff',
                }}
              >
                {isAdmin && m.senderName && (
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#666',
                      marginBottom: 4,
                    }}
                  >
                    {m.senderName}
                  </div>
                )}
                <div
                  style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                  {m.message}
                </div>
                <AttachmentViewer attachments={m.attachments} />
                <div
                  style={{
                    fontSize: 11,
                    marginTop: 4,
                    opacity: 0.8,
                  }}
                >
                  {formatTime(m.createdAt)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div ref={bottomRef} />
    </Card>
  );
};
